import { library } from '@fortawesome/fontawesome-svg-core'
import { faTwitter, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

library.add(faTwitter, faFacebookF, faLinkedinIn)